import { AppScope, AuthorizationRole } from '../../utils/authorizationModel'

export type AuthorizationSource = 'auth0' | 'url-jwt' | 'canvas'

export interface AuthorizationState {
  source: AuthorizationSource | null
  partnerId: string | null
  partnerUserId: string | null
  roles: AuthorizationRole[]
  scopes: AppScope[]
  claimsLoaded: boolean
  isAuthenticated: boolean
}

export enum AuthorizationActionTypes {
  HYDRATE_AUTHORIZATION = 'HYDRATE_AUTHORIZATION',
  CLEAR_AUTHORIZATION = 'CLEAR_AUTHORIZATION',
}

type HydrateAuthorizationPayload = Partial<
  Omit<AuthorizationState, 'claimsLoaded' | 'isAuthenticated'>
> & {
  claimsLoaded?: boolean
  isAuthenticated?: boolean
}

type AuthorizationAction =
  | {
      type: AuthorizationActionTypes.HYDRATE_AUTHORIZATION
      payload: HydrateAuthorizationPayload
    }
  | {
      type: AuthorizationActionTypes.CLEAR_AUTHORIZATION
    }

export const initialState: AuthorizationState = {
  source: null,
  partnerId: null,
  partnerUserId: null,
  roles: [],
  scopes: [],
  claimsLoaded: false,
  isAuthenticated: false,
}

export const AuthorizationReducer = (
  state = initialState,
  action: AuthorizationAction
): AuthorizationState => {
  switch (action.type) {
    case AuthorizationActionTypes.HYDRATE_AUTHORIZATION: {
      return {
        ...state,
        ...action.payload,
        claimsLoaded: action.payload.claimsLoaded ?? true,
        isAuthenticated: action.payload.isAuthenticated ?? true,
      }
    }
    case AuthorizationActionTypes.CLEAR_AUTHORIZATION:
      return initialState
    default:
      return state
  }
}
